import React from 'react';

export default () => {
  return <div>Accounts</div>;
};
